import { Controller } from "@hotwired/stimulus"

// Shows a sticky CTA bar at the bottom of mobile screens
// after the user scrolls past the hero section.
// Research: +25% sales from sticky CTAs (Conversion Rate Experts)
export default class extends Controller {
  static targets = ["bar"]

  connect() {
    this.visible = false
    this.handleScroll = this.handleScroll.bind(this)
    window.addEventListener("scroll", this.handleScroll, { passive: true })
    this.handleScroll()
  }

  disconnect() {
    window.removeEventListener("scroll", this.handleScroll)
  }

  handleScroll() {
    // Show after scrolling 500px (past hero section)
    const shouldShow = window.scrollY > 500
    if (shouldShow === this.visible) return

    this.visible = shouldShow
    if (shouldShow) {
      this.barTarget.classList.remove("translate-y-full")
      this.barTarget.classList.add("translate-y-0")
    } else {
      this.barTarget.classList.remove("translate-y-0")
      this.barTarget.classList.add("translate-y-full")
    }
  }
}
